export default __webpack_public_path__ + "static/media/twitter.711d1e97.svg";